var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-title d-flex justify-content-between align-items-center mb-md-4 mb-3 mt-4"},[_c('div',[_c('h4',{staticClass:"sub-heading"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.subtitle))])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }